import type { CurrentUser } from "../hooks/useCurrentUser";

/**
 * Has the user WALKED the profiling conversation? This is the Explore gate
 * (`AppRoutes`): `/discovery` and its sub-routes route into
 * `/onboarding/interests` until this is true.
 *
 * Keyed on the durable completion stamp (`preferenceOnboardingCompletedAt`,
 * served as `preferenceOnboarding.status`), which ONLY the conversation's own
 * finish action writes — deliberately not on "the user has interests". Interests
 * arrive by other doors: JuisciGPT's `suggestTopicInterests` confirmation card
 * and the plain topic picker both `PUT /users/me/interests`, and a resolved
 * search can still enrich the legacy `meshInterests`. Gating on the interests
 * themselves would let every one of those silently open Explore for a user who
 * never saw the conversation — and the conversation is the point: it is where
 * the feed taste turn is asked and where the learned topics get confirmed.
 *
 * `snoozed` does not pass either. The 14-day snooze was the bottom-sheet nudge's
 * escape hatch; the page has no skip, so a snoozed user simply walks it.
 */
export function hasCompletedFeedProfiling(user: CurrentUser | null): boolean {
  if (user === null) return false;
  return user.preferenceOnboarding.status === "completed";
}
